import "./Footer.scss";
import { footerLogoWhite, upArrow } from "../../service/image";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const startYear = 2026;
  const currentYear = new Date().getFullYear();

  const yearDisplay =
    currentYear > startYear ? `${startYear}-${currentYear}` : startYear;

  return (
    <footer>
      <div className="container">
        <div className="footer__items">
          <div className="footer__item row">
            <p>Site creator: Erik Yeghiazaryan</p>
            <p>All rights reserved: {yearDisplay}</p>
          </div>

          <div className="footer__logo">
            <a href="/">
              <img src={footerLogoWhite} alt="Logo image" />
            </a>
          </div>

          <div className="footer__item row">
            <a href="mailto:goodprogramwork@gmail.com">
              goodprogramwork@gmail.com
            </a>
          </div>
        </div>
      </div>

      <div onClick={scrollToTop} className="arrow">
        <img src={upArrow} alt="Arrow icon" />
      </div>
    </footer>
  );
};

export default Footer;
